<template>
  <PageLayout>
    <div @scroll="handleScroll" class="booking-order">
      <!-- DESKTOP BREADCRUMB -->
      <div class="d-none d-md-none d-lg-block">
        <b-row v-if="!isFriendFamily && !isWeddingAbroad">
          <b-col class="breadcrumb-itinerary">
            <Breadcrumbs />
          </b-col>
        </b-row>
      </div>

      <div>
        <!-- MOBILE BREADCRUMB -->
        <div class="d-block d-lg-none">
          <b-row>
            <b-col class="breadcrumb-itinerary-mobile">
              <Breadcrumbs />
            </b-col>
          </b-row>
        </div>
        <!-- -->

        <div class="destination-info-block overflow-inherit mt-0">
          <div class="hero-img-background">
            <img
              v-if="hero"
              :src="resizedHero"
              class="hero-img img-responsive"
              alt="Hero-image"
            />
            <div class="itin-tabs container" content-class="mt-3">
              <!-- Itinerary title -->
              <div class="title-container">
                <div class="title-sub-container text-center">
                  <!-- Itinerary TITLES -->
                  <!-- Wedding -->
                  <div
                    v-if="
                      isWedding === 'true' ||
                      (isWedding === 'true' && honeymoon === 'true')
                    "
                    class="itinerary-title"
                  >
                    Your Wedding Abroad
                  </div>
                  <!-- Honeymoon -->
                  <div
                    v-if="honeymoon === 'true' && isWedding === 'false'"
                    class="itinerary-title"
                  >
                    Your Honeymoon
                  </div>
                  <!-- Package -->
                  <div
                    v-if="
                      tripType === 'PA' &&
                      isWedding === 'false' &&
                      honeymoon === 'false'
                    "
                    class="itinerary-title"
                  >
                    Tailormade travel itinerary for
                  </div>
                  <!-- Flights Only -->
                  <div
                    v-if="
                      isWedding === 'false' &&
                      honeymoon === 'false' &&
                      tripType !== 'PA'
                    "
                    class="itinerary-title"
                  >
                    Booking for
                  </div>

                  <!-- Client Name Mobile -->
                  <div class="client-name d-block d-md-none">
                    <!-- Show Couple Names -->
                    <div v-if="(isWedding === 'true' || honeymoon === 'true') && booking && booking.user_information && booking.user_information.names_plus" class="d-flex flex-column" >
                      <a 
                        v-for="client of getTravellingPassengers(booking.user_information.names_plus)" 
                        :key="client.name"
                        @click="openThisBookingModal"
                      >
                        {{ formatName(client.name) }}
                      </a>
                    </div>
                    <!-- Show Lead Name -->
                    <a v-else-if="leadClientData && leadClientData.name" @click="openThisBookingModal" class="client-name">
                      {{formatName(leadClientData.name)}}
                    </a>
                  </div>

                  <!-- Client Name(s) Tablet/Desktop -->
                  <div class="d-none d-md-block">
                    <!-- Clients >= 5 -->
                    <div v-if="hasMultipleClients" class="client-name">
                      <b-row class="d-flex justify-content-center m-0">
                        <b-col md="5" lg="4" class="p-0">
                          <a @click="openThisBookingModal" class="client-name">
                            {{ formatName(leadClientData.name) }}
                          </a>
                        </b-col>
                        <b-col md="5" lg="4" class="p-0">
                          <p class="client-passport">
                            {{ formatName(leadClientData.passport) }}
                          </p>
                        </b-col>
                      </b-row>
                      <b-row class="d-flex justify-content-center m-0">
                        <b-col>
                          <p
                            @click="openThisBookingModal"
                            class="all-names-text"
                          >
                            view all names +
                          </p>
                        </b-col>
                      </b-row>
                    </div>
                    <!-- Clients <= 4 -->
                    <div v-else-if="booking && booking.user_information">
                      <b-row 
                        v-for="client of getTravellingPassengers(booking.user_information.names_plus)"
                        :key="client.name" 
                        class="d-flex justify-content-center m-0 client-name"
                      >
                        <b-col md="5" lg="4" class="p-0">
                          <a @click="openThisBookingModal" class="client-name">
                            {{ formatName(client.name) }}
                          </a>
                        </b-col>
                        <b-col md="5" lg="4" class="p-0">
                          <p class="client-passport">
                            {{ formatName(client.passport) }}
                          </p>
                        </b-col>
                      </b-row>
                    </div>
                  </div>

                  <!-- Consultant Info -->
                  <p class="prepared-text">Prepared for you by</p>
                  <div v-if="consultantInfo && consultantInfo.name" class="consultant-name">
                    <a v-if="consultantInfo && consultantInfo.name" @click.prevent="openConsultantModal" class="consultant-tooltip">
                      {{ capitalise(consultantInfo.name)  }}
                      <span class="consultant-tooltip-text">Your Consultant</span>
                    </a>
                  </div>
                </div>
              </div>
              <Itinerary />
              <DestinationAdvice v-if="fil === 'P' && DestinationAdvice && DestinationAdvice.length" class="mb-5" />
              <TripCostPayments v-if="fil === 'P' && !hasPaid" class="mb-5" />
              <FooterLinks />
            </div>
          </div>
        </div>
      </div>
    </div>
    <ThisBookingIsFor ref="ThisBookingIsForModal" />
    <AmexStatus ref="AmexStatusRef" />
    <ConsultantModal ref="ConsultantModalRef" />
  </PageLayout>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { amexUpdate } from "./services";
import PageLayout from "@/partials/page-layout";
import TripCostPayments from "./trip-cost-payments";
import DestinationAdvice from "./destination-advice";
import FooterLinks from "./footer-links";
import Itinerary from "./itinerary";
import AmexStatus from "@/partials/amex-status";
import ConsultantModal from "@/modules/navigation/modals/consultant-info";
import { bus } from "@/main";
import ThisBookingIsFor from "@/modules/navigation/modals/this-booking";
export default {
  components: {
    PageLayout,
    FooterLinks,
    TripCostPayments,
    DestinationAdvice,
    Itinerary,
    AmexStatus,
    ConsultantModal,
    ThisBookingIsFor,
  },
  data() {
    return {
      tabIndex: 0,
      displayPricingTab: true, // Used by F&F,
      loginRes: {},
      activeTab: "itinerary",
      weddingAbroad: "",
    };
  },
  computed: {
    ...mapGetters({
      accountInfo: "booking/getAccount",
      booking: "booking/getBooking",
      consultantInfo: "booking/getConsultantInformation",
      cruise: "booking/getCruise",
      destination: "booking/getDestination",
      fil: "booking/getFil",
      hero: "booking/getHeroImage",
      honeymoon: "booking/getHoneymoon",
      isWedding: "booking/getWeddingAbroad",
      itinerary: "booking/getItineraryRaw",
      paymentDue: "booking/getNextPaymentDue",
      tripType: "booking/getTripType",
      DestinationAdvice: "booking/getDestinationAdvice",
    }),
    ...mapGetters("friendFamily", ["isFriendFamily", "displayPricing"]),
    ...mapGetters("weddingAbroad", ["isWeddingAbroad", "displayPricing"]),
    isCruise() {
      if (this.cruise === true) {
        return true;
      }
      let cruise = false;
      for (
        let i = 0;
        i < this.booking.booking_itinerary.itinerary.length;
        i++
      ) {
        for (
          let j = 0;
          j < this.booking.booking_itinerary.itinerary[i].data.length;
          j++
        ) {
          if (
            this.booking.booking_itinerary.itinerary[i].data[j].hasOwnProperty(
              "tourtype"
            ) &&
            this.booking.booking_itinerary.itinerary[i].data[j].tourtype ===
              "CRUISE"
          ) {
            cruise = true;
          }
        }
      }
      return cruise;
    },
    resizedHero() {
      const w = 1280;
      const url = new URL(this.hero.url);
      if (url.hostname === "cdn.trailfinders.com") {
        url.searchParams.set("width", w.toString());
      }
      return [url.toString()];
    },
    isTour() {
      return this.itinerary.jsontypes.includes("tour");
    },
    includesHotel() {
      return this.itinerary.jsontypes.includes("hotel");
    },
    hasPaid() {
      if (
        this.accountInfo.paidCost === false ||
        this.accountInfo.paidCost === "£0.00" ||
        this.accountInfo.paidCost === "€0.00"
      ) {
        return false;
      }
      return true;
    },
    hasMultipleClients() {
      if(this.booking && this.booking.user_information && this.booking.user_information.names_plus.length >= 5) {
        return true
      }
      return false;
    },
    leadClientData() {
      const clients = this.booking && this.booking.user_information ? this.booking.user_information.names_plus.map(client => client) : []
      return clients[0]
    }
  },
  async created() {
    if (this.$route.name === "friendandfamily") {
      await this.friendAndFamily();
    }
    if (this.$route.name === "weddingabroad") {
      await this.wedding();
    }

    if (
      this.$route.name === "bookingauthsource" ||
      this.$route.name === "bookingauth" ||
      this.$route.name === "bookingauthcomponent" ||
      this.$route.name === "amexPayment"
    ) {
      this.loginRes = await this.loginOnStart({
        username: this.$route.params.surname,
        bookingNumber: this.$route.params.bookingNumber,
        source: this.$route.params.source,
      });
    }
    if (!this.loginRes) {
      this.$router.push("/login");
    }
    if (this.$route.name === "amexPayment") {
      const payload = {
        status: this.$route.query.status,
        request_id: this.$route.query.request_id,
        transaction_details: this.$route.query.transaction_details,
      };
      let result = await amexUpdate(payload);
      this.$store.dispatch("spinner/updateLoadingAction", false, {
        root: true,
      });

      if (result.error) {
        this.errorLoadingData = true;
        return;
      }
      if (result.data) {
        // display AMEX Modal
        this.$refs.AmexStatusRef.showModal(result.data);
      }
    }
    if (this.$route.name === "bookingauthcomponent") {
      // Display a modal if its availble
      bus.$emit("displayComponent", this.$route.params.component);
    }
    if (this.$route.hash === "#price") {
      this.activeTab = "tabsPriceNextSteps";
    }
    this.stopLoading();
  },
  mounted() {
    // Listen for scrolling
    window.addEventListener("scroll", this.handleScroll);
  },
  watch: {
    async $route(to, from) {
      // Watching for AMEX route change
      if (to.name === "amexPayment") {
        const payload = {
          status: this.$route.query.status,
          request_id: this.$route.query.request_id,
          transaction_details: this.$route.query.transaction_details,
        };
        let result = await amexUpdate(payload);
        this.$store.dispatch("spinner/updateLoadingAction", false, {
          root: true,
        });

        if (result.error) {
          this.errorLoadingData = true;
          return;
        }
        if (result.data) {
          // display AMEX Modal

          this.$refs.AmexStatusRef.showModal(result.data);
        }
      }
    },
  },
  methods: {
    ...mapActions({
      loginOnStart: "auth/loginBookingNumberOnStartAction",
      decodeUNID: "friendFamily/decodeUNID",
      decodeWeddingUNID: "weddingAbroad/decodeWeddingUNID",
    }),
    stopLoading() {
      this.$emit("loading-bar", false);
    },
    switchTabByRef(_ref) {
      if (this.$refs[_ref]) {
        this.$refs[_ref].activate();
      }
    },
    handleScroll() {
      // Get elements that need to be changed
      if (document.querySelector(".breadcrumb-itinerary")) {
        const desktopBreadcrumb = document.querySelector(
          ".breadcrumb-itinerary"
        );
        const mobileBreadcrumb = document.querySelector(
          ".breadcrumb-itinerary-mobile"
        );
        const container = document.querySelector(".vtd-section-info");
        
        // If window is greater than 992 px and user has scrolled more than 750px then add classes
        if (window.scrollY > 75 && window.innerWidth > 992) {
          desktopBreadcrumb.classList.add("fixed-breadcrumbs");
          container.classList.add("fixed-nav-block");
          // If window is less than 992 px and user scrolls more than 85 px add classes
        } else if (window.scrollY > 75 && window.innerWidth < 992) {
          mobileBreadcrumb.classList.add("fixed-breadcrumbs");
          container.classList.add("fixed-nav-block");
          // Otherwise remove classes
        } else {
          desktopBreadcrumb.classList.remove("fixed-breadcrumbs");
          mobileBreadcrumb.classList.remove("fixed-breadcrumbs");
          container.classList.remove("fixed-nav-block");
        }
      }
    },
    openConsultantModal() {
      this.$refs["ConsultantModalRef"].showModal();
    },
    checkIfHoneyMoon() {
      if (this.honeymoon === "true" && this.isWeddingAbroad !== "true") {
        return true;
      }
    },
    checkIfWeddingAbroad() {
      if (this.isWeddingAbroad === "true") {
        return true;
      }
    },
    async friendAndFamily() {
      // Extract booking information via UNID service
      const result = await this.decodeUNID(this.$route.params.unid);

      // Didnt set friendandfamily so go to login
      if (this.isFriendFamily === false) {
        return this.$router.push("/login");
      }
      if (this.displayPricing === false) {
        this.displayPricingTab = false;
      }
      // if state is true then go ahead and call loginOnstart

      this.loginRes = await this.loginOnStart({
        username: this.$store.state.friendFamily.bookingName,
        bookingNumber: this.$store.state.friendFamily.bookingNumber,
      });
      // Still failed go to login
      if (!this.loginRes) {
        this.$router.push("/login");
      }
    },
    async wedding() {
      // Extract booking information via UNID service
      const result = await this.decodeWeddingUNID(this.$route.params.unid);

      // Didnt set friendandfamily so go to login
      if (this.isWeddingAbroad === false) {
        return this.$router.push("/login");
      }
      if (this.displayPricing === false) {
        this.displayPricingTab = false;
      }
      // if state is true then go ahead and call loginOnstart

      this.loginRes = await this.loginOnStart({
        username: this.$store.state.weddingAbroad.bookingName,
        bookingNumber: this.$store.state.weddingAbroad.bookingNumber,
      });
      // Still failed go to login
      if (!this.loginRes) {
        this.$router.push("/login");
      }
    },
    formatName(text) {
      text = text.toLowerCase();
      let re = /(\b[a-z](?!\s))/g;
      let regexText = text.replace(re, (x) => x.toUpperCase());

      return regexText;
    },
    openThisBookingModal() {
      this.$refs["ThisBookingIsForModal"].showModal();
    },
    getTravellingPassengers(_clients) {
      // removes clients who are cancelled off the booking
      return _clients.filter((cli) => cli.canx !== "CANX");
      // return _clients
    },
    capitalise(text){
      const separators =  [ " ", "-" ];
      const regex = new RegExp('(^|[' + separators.join('') + '])(\\w)', 'g');
      return text.toLowerCase().replace(regex, function(x) { return x.toUpperCase(); });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>
